import React, { Component, useContext, useState } from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { useLazyQuery } from '@apollo/client';
import { AdminContext } from '../../containers/Admin';
import { useParams } from 'react-router';

const style = {
  app: {
    backgroundColor: 'rgba(0,0,0,0.1)',
    width: 'auto',
  },
  select: {},
};

export const OfficeDropdown = (props: {
  wrapper_style?: any;
  option_style?: any;
  onChange?: any;
  selected?: { value: string; label: string };
}) => {
  const params = useParams<{ kontor: string }>();
  const [is_loaded, setLoaded] = React.useState(false);
  const [selected, setSelected] = React.useState(props.selected);
  const [options, setOptions] = React.useState(new Array<any>());

  if (is_loaded != true) {
    const context = useContext(AdminContext);

    if (
      context?.adminState?.loggedIn?.user?.offices &&
      context?.adminState?.loggedIn?.user?.offices.length > 1
    ) {
      if (options.length < 1) {
        context.adminState.loggedIn.user.offices.map((e: any) => {
          options.push({
            value: e.urltag,
            label: e.name,
          });
        });
      }

      if (options.length > 1) {
        if (selected == null || selected == undefined) {
          var indx = context.adminState.loggedIn.user.offices.findIndex(
            (e: any) =>
              e &&
              (params.kontor
                ? e.urltag == params.kontor
                : e.urltag && e.is_default == true)
          );

          if (indx < 0) indx = 0;

          if (indx > -1) {
            setSelected({
              value: context.adminState.loggedIn.user.offices[indx].urltag,
              label: context.adminState.loggedIn.user.offices[indx].name,
            });
          }
        }

        if (options.length > 0) {
          setLoaded(true);
        }
      }
    }
  }

  const OnChange = (e: any) => {
    setSelected(e);
    if (props.onChange) props.onChange(e);
  };

  return !is_loaded ? null : (
    <DropdownWrap style={props.wrapper_style} >
      <Select
        options={options}
        style={props.option_style}
        onChange={OnChange}
        value={selected}
      />
    </DropdownWrap>
  );
};

const DropdownWrap = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  width: 200px;
  z-index: 2;
  color: #000;
  max-height:100px;
  justify-content: unset;
`;
